
<ol type="1">
  <li *ngFor="let score of scores | async">
    {{score}}
  </li>
</ol>

<div id="padree">
    <iframe class="responsive-iframe" src="https://datastudio.google.com/embed/reporting/0bc78d52-7848-4e30-9d7a-df4d286e22e3/page/nFKmB" frameborder="0" style="border:0" allowfullscreen></iframe>
</div>